module.exports = __webpack_public_path__ + "img/BRCA3_B.123a10c4.png";